module.exports = __webpack_public_path__ + "img/cover-kinder.97ab7ec1.jpg";